(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-zabelia"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const searchToggle = document.querySelector('.header-search-toggle');
    const searchOverlay = document.querySelector('.header-search-overlay');
    const searchClose = document.querySelector('.header-search-close');
    const searchInput = document.querySelector('.header-search-input');

    if (searchToggle && searchOverlay) {
      searchToggle.addEventListener('click', function() {
        searchOverlay.classList.add('active');
        if (searchInput) searchInput.focus();
      });
    }

    if (searchClose && searchOverlay) {
      searchClose.addEventListener('click', function() {
        searchOverlay.classList.remove('active');
      });
    }

    if (searchOverlay) {
      searchOverlay.addEventListener('click', function(e) {
        if (e.target === searchOverlay) {
          searchOverlay.classList.remove('active');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-zabelia"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsSlider {
    constructor(element) {
      this.element = element;
      this.track = element.querySelector('[data-testimonials-track]');
      this.cards = element.querySelectorAll('[data-testimonial-card]');
      this.prevBtn = element.parentElement.querySelector('.testimonials-section__nav--prev');
      this.nextBtn = element.parentElement.querySelector('.testimonials-section__nav--next');
      this.currentIndex = 0;
      this.cardsPerView = this.getCardsPerView();

      if (this.prevBtn && this.nextBtn && this.cards.length > this.cardsPerView) {
        this.init();
      }
    }

    getCardsPerView() {
      const width = window.innerWidth;
      if (width <= 768) return 1;
      if (width <= 900) return 2;
      if (width <= 1200) return 3;
      return 4;
    }

    init() {
      this.prevBtn.addEventListener('click', () => this.prev());
      this.nextBtn.addEventListener('click', () => this.next());
      this.updateButtons();

      let startX = 0;
      let currentX = 0;
      let isDragging = false;

      this.track.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.clientX;
        this.track.style.cursor = 'grabbing';
      });

      this.track.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        currentX = e.clientX;
      });

      this.track.addEventListener('mouseup', () => {
        if (isDragging) {
          const diff = startX - currentX;
          if (Math.abs(diff) > 50) {
            if (diff > 0) this.next();
            else this.prev();
          }
          isDragging = false;
          this.track.style.cursor = 'grab';
        }
      });

      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      });

      this.track.addEventListener('touchmove', (e) => {
        currentX = e.touches[0].clientX;
      });

      this.track.addEventListener('touchend', () => {
        const diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) this.next();
          else this.prev();
        }
      });

      window.addEventListener('resize', () => {
        this.cardsPerView = this.getCardsPerView();
        this.currentIndex = Math.min(this.currentIndex, this.getMaxIndex());
        this.slide();
      });
    }

    getMaxIndex() {
      return Math.max(0, this.cards.length - this.cardsPerView);
    }

    next() {
      if (this.currentIndex < this.getMaxIndex()) {
        this.currentIndex++;
        this.slide();
      }
    }

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.slide();
      }
    }

    slide() {
      const cardWidth = this.cards[0].offsetWidth;
      const gap = 16;
      const offset = -(cardWidth + gap) * this.currentIndex;
      this.track.style.transform = `translateX(${offset}px)`;
      this.updateButtons();
    }

    updateButtons() {
      if (this.prevBtn) {
        this.prevBtn.disabled = this.currentIndex === 0;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = this.currentIndex >= this.getMaxIndex();
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sliderElement = document.querySelector('[data-testimonials-slider]');
    if (sliderElement) {
      new TestimonialsSlider(sliderElement);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
